import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { dateIcon } from "../assets/imgs";
import { LabelContainer } from "../assets/style";
import { formatDate } from "../utils/dateTimeFormmater";

export default function HookFormDatePicker<T extends FieldValues>(props: { title: any, name: Path<T>, control: Control<T, any>, style?: any }) {
    const { title, name, control, style } = props
    const datePickerStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        // height: "100px",
        width: "100%",
        ...style,
    }
    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "400px",
    };
    return (
        <div style={containerStyle}>
            <LabelContainer >
                {title + ": "}
            </LabelContainer>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { name, value, onChange, ref } }) => (
                        <DatePicker
                            format="DD/MM/YYYY"
                            sx={datePickerStyle}
                            name={name}
                            value={dayjs(value, "DD/MM/YYYY")}
                            ref={ref}
                            onChange={(x) => onChange(x?.format("DD/MM/YYYY"))}
                            slots={{
                                openPickerIcon: DateIcon
                            }}
                            slotProps={{ textField: { size: 'small', color: 'primary' } }}
                        />
                    )}
                />
            </LocalizationProvider>

        </div>
    );
}

function DateIcon() {
    return (
        <img src={dateIcon} alt="" />
    );
}
